<template>
<div>
  <div class="heading-common is-btn-back">
    <a class="btn-back" @click="goBack">
    <div class="arrow-back"></div>
    </a> 
    <p class="name">{{ sectionData.title }}</p>
  </div>
  <div style="position: relative"
    :class="['lesson-list', 'bg', (classOpened ? 'bg-'+classCategory : '')]">

      <div v-show="lessonList.length" v-for="(row, lesson_idx) in lessonList"
      :class="['lesson', 
      (classExam(row.lesson_type) ? 'exam' : ''), 
      ((classExam(row.lesson_type) && classOpened) ? 'exam-bg-'+classCategory : ''), 
      row.lesson_number ? 'lesson-' + row.lesson_number :'',
      classLocked(row.status) ? 'lesson-locked' : '',
      classCompleted(row.status) ? 'lesson-completed' : '',
       ]" 
      @click.prevent="selectLessonItem(row)">
          <div class="number font-jp">
              <i v-if="classExam(row.lesson_type)" class="material-icons">verified</i>
              <p v-else>{{ row.lesson_number }}.</p>
          </div>

          <div class="grammar-access">
            <div class="grammar font-jp">
                <template v-if="row"><p v-html="row.title"></p></template><template v-else><p></p></template>
            </div>
            <div class="status"></div>
            <div class="lesson-link"></div>
          </div>
      </div>
  </div>
</div>

</template>

<script>
  import {api, appEnv, useCoachmark} from "../../config";
  import {mapState} from 'vuex';
  import status from '../../mixins/status';


import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';


  export default {
    mixins: [
      status
    ],
    // components: {
    //   'lessonmodal': LessonModal
    // },
    props: {
      category: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        step: 'category',
        authUser: null,
        driver: null,
        storage: {}
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      sectionData() {
        return this.$store.getters.section_data;
      },
      lessonList() {
         return this.$store.getters.lessons
      },
      classCategory() {
        return this.$store.getters.section_data.sort
      },
      classExam: function() {
        return function(lesson_type) {
          return (lesson_type == 'exam')
        }
      },
      classCompleted: function() {
        return function(status) {
          return (status == 'completed')
        }
      },
      classLocked: function() {
        return function(status) {
          if(this.sectionData.section == 'hiragana' || this.sectionData.section == 'katakana') {
            return (status == 'incomplete')
          } else {
            return false
          }
        }
      },
      classOpened: function() {
        return (this.$store.getters.section_data.status !== 'incomplete')
      }
    },

    created() {
      let self = this;
      
      self.authUser = self.$store.getters.getAuthUser;
      
      
      if(this.driver) {
        this.driver.reset();
      } else {
        this.initCoachMark();
      }

      self.$store.dispatch('showLoading', true)
      
      axios.get(api.lessons, {
        params: {
          section_id: self.$store.getters.section_data.section_id,
          section_status: self.$store.getters.section_status
        }
      })
      .then((resp) => {
        self.$store.dispatch('setLessons',  resp.data)
        self.$store.dispatch('showLoading', false)
        
        // categoryのcoach markはここで呼ぶ
        if(useCoachmark) {
          self.storage = (appEnv === 'production') ? window.localStorage : window.sessionStorage
          
          const isCoachmarkDone = self.storage.getItem("coachmarkdone") ? JSON.parse(self.storage.getItem("coachmarkdone")) : null;
          if(!(isCoachmarkDone && self.step in isCoachmarkDone && isCoachmarkDone[self.step])) {
            self.showCoachMark();
          }
        }
      
      })
      .catch(err => {
        self.$store.dispatch("showLoading", false);
      });
    },

    mounted() {
      if(appEnv !== 'local') {
        const TypeSquareJS = window.TypeSquareJS;
        TypeSquareJS.loadFont && TypeSquareJS.loadFont();
      }
    },
    methods: {

      selectLessonItem(row) {
        
        if(this.driver) {
          this.driver.reset();
        }
        
        if(this.classLocked(row.status)) {
          return false
        }
        
        this.$store.dispatch('showLoading', true);
        this.$store.dispatch('setLessonData', row);
        this.$store.dispatch("setLessonStatus", row.status);

        // Update status the first time
        if (this.$store.getters.lesson_status == 'ready') {
          this.statusLesson('start');
        }

        // Get the contents of a Session or Exam
        let lessonData = this.$store.getters.lesson_data
        axios.get(api.contents, {
          params: {
            section_id: this.$store.getters.section_data.section_id,
            lesson_id: this.$store.getters.lesson_data.lesson_id,
            lesson_type: this.$store.getters.lesson_data.lesson_type
          }
        })
        .then((resp) => {
          this.$store.dispatch('setLessonContent',  resp.data)
          this.$store.dispatch('showLoading', false)

          let push_val = { name: 'lesson.movie', params: { lesson_id: lessonData.lesson_id, content_order: 1 }}
          if (lessonData.lesson_type == 'exam') {
            push_val = {name: 'lesson.explanation', params: { lesson_id: lessonData.lesson_id, step: 'exam' }}
          }
          this.$router.push(push_val)
        })
        .catch(err => {
          this.$store.dispatch("showLoading", false);
        });
      },
      initCoachMark() {
        if(this.driver) {
          this.driver.reset()
        } else {
          const driverOverlay = document.getElementById('driver-page-overlay')
          const driverStage = document.getElementById('driver-highlighted-element-stage')
          const driverItem = document.getElementById('driver-popover-item')
          const driverItem2 = document.getElementById('driver-popover-item2')
          
          if(driverOverlay) {
            driverOverlay.remove()
          }
          if(driverStage) {
            driverStage.remove()
          }
          if(driverItem) {
            driverItem.remove()
          }
        }
      },
      showCoachMark() {
        let self = this;
        if(!this.authUser) return false;

         this.driver = new Driver({
            className: "scoped-class-dark",
            animate: true,
            opacity: 0.7,
            padding: 10,
            allowClose: true,
            overlayClickNext: false,
            DoneBtnText: "Done",
            CloseBtnText: "Close",
            NextBtnText: "Next",
            PrevBtnText: "Previous step",
            onReset: (e) => {
            
              let coachMarks = JSON.parse(this.storage.getItem("coachmarkdone")|| null);
              if(!coachMarks) {
                coachMarks = {};
                coachMarks[this.step] = true;
              } else {
                coachMarks[this.step] = true;
              }

              this.storage.setItem("coachmarkdone", JSON.stringify(coachMarks));
            }
        })
        setTimeout(() => {
          this.driver.highlight({
            element: '.lesson.lesson-1',
            popover: {
              className: 'popover-class',
              title: 'click to Start Lesson',
            }
          })
        },300)
      },
      goBack() {
        this.$router.push({ name: 'lesson' });
      }
    }
  }
</script>
